import { styled, StyleSystemProps, Box, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledCountdownGiftCountContainer = styled(Box)``;
const countdownGiftCountContainerStyles: StyleSystemProps = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: `${pxToRem(58)} ${pxToRem(156)}`,
  width: '100%',
  height: pxToRem(214),
  borderRadius: 3,
  backgroundColor: 'white',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04)'
};

export const StyledArea = styled(Flex)``;
const commonAreaStyles: StyleSystemProps = {
  cursor: 'pointer',
  userSelect: 'none',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'backgroundColor 0.25s',
  _hover: {
    backgroundColor: '#fbfbfb'
  }
};

const countdownAreaStyles: StyleSystemProps = {
  justifyContent: 'center',
  alignItems: 'center',
  gridArea: '1 / 1 / 2 / 3',
  borderBottom: '1px solid',
  borderColor: 'mono3'
};

const availableAreaStyles: StyleSystemProps = {
  ...commonAreaStyles,
  flexDirection: 'column',
  gridArea: '2 / 1 / 3 / 2',
  borderRight: '1px solid',
  borderColor: 'mono3'
};

const purchasedAreaStyles: StyleSystemProps = {
  ...commonAreaStyles,
  flexDirection: 'column',
  gridArea: '2 / 2 / 3 / 3'
};

const skeletonGroupStyles: StyleSystemProps = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column'
};

export const styles = {
  countdownGiftCountContainer: countdownGiftCountContainerStyles,
  countdownArea: countdownAreaStyles,
  availableArea: availableAreaStyles,
  purchasedArea: purchasedAreaStyles,
  skeletonGroup: skeletonGroupStyles
};
